import { render, staticRenderFns } from "./Pobs.vue?vue&type=template&id=47537615&"
import script from "./Pobs.vue?vue&type=script&lang=js&"
export * from "./Pobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports